<template>
  <div ref="editorDOM">
    <div class="windowInfoWrap m-main" ref="innerDOM">
      <div class="title">体检套餐</div>
      <div class="mobileTable" v-if="SCREEN.mobile">
        <div
          class="tableData"
          v-for="(item, index) in medicalExamData"
          :key="index"
        >
          <div class="item" @click="savePhysicalEaxmInfo(item)">
            <div class="left">套餐名称：</div>
            <div class="right">{{ item.packageName }}</div>
          </div>
          <div class="item">
            <div class="left">所属性别：</div>
            <div class="right">
              {{ item.packageSex }}
            </div>
          </div>
          <div class="item">
            <div class="left">套餐价格：</div>
            <div class="right">{{ item.packagePrice }}</div>
          </div>
        </div>
      </div>
      <div class="tablebox" v-else>
        <a-table
          :columns="columns"
          :data-source="medicalExamData"
          :pagination="false"
        >
          <span slot="action" slot-scope="text, record">
            <a
              slot="action"
              href="javascript:;"
              @click="savePhysicalEaxmInfo(record)"
              >{{ text }}</a
            >
          </span>
          <span slot="packageSex" slot-scope="text, record">
            <span>{{record.packageSex}}</span>
          </span>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "hospital-physicalExaminationPackageList-001",
  data() {
    return Object.assign(
      {
        columns: [
          {
            title: "套餐名称",
            dataIndex: "packageName",
            key: "packageName",
            scopedSlots: {
              customRender: "action"
            }
          },
          {
            title: "所属性别",
            dataIndex: "packageSex",
            key: "packageSex",
            scopedSlots: {
              customRender: "packageSex"
            }
          },
          {
            title: "套餐价格",
            dataIndex: "packagePrice",
            key: "packagePrice"
          }
        ],
        ExamDataLabel:[],
        medicalExamData: [
          // {
          //   packageName: "全面体检套餐（女未婚）",
          //   packageSex: "女未婚",
          //   packagePrice: "￥1220.50（单价：元）",
          // packageCode
          // },
          // {
          //   packageName: "全面体检套餐（男）",
          //   packageSex: "男",
          //   packagePrice: "￥1200.50（单价：元）"
          // }
        ]
      }
    );
  },

  mounted() {
    this.getMedicalExamLabel();
  },

  methods: {
    savePhysicalEaxmInfo(item) {
      this.$router.push({
          path: '/medicalCenter/medicalPackageDetails',
          query: { packageSex:item.packageSex,packageCode: item.packageCode},
        })
    },
    getMedicalExamLabel() {
      this.$API
        .getMedicalExamLabel({
          hospitalCode: "H05",
          // packageRange: "5",
          // labelName:'优享套餐',
          // labelId:10
        })
        .then(res => {
          // this.$set(this, "medicalExamData", res.data);
          this.$set(this, "ExamDataLabel", res.data);
            for(let i=0; i<this.ExamDataLabel.length;i++){
              let par ={
                hospitalCode: "H05",
                // packageRange: "5",
                // labelName: this.ExamDataLabel[i].labelName,
                labelId:this.ExamDataLabel[i].labelId
              }
              this.$API.getMedicalExamList(par).then((res) => {
                if(res.code==0){
                  this.medicalExamData = this.medicalExamData.concat(res.data);
                }
              })
            }
        });
    }
  }
};
</script>

<style lang="less" scoped>
.title{
  font-size: 24px;
  display: flex;
  justify-content: center;
  padding-top: 30px;
  margin-bottom: 30px;
}
.mobileTable {
  padding-top: 0.4rem;
  .tableData {
    margin-bottom: 0.2rem;
    .item {
      border-top: 1px solid #ddd;
      display: flex;
      justify-content: center;
      font-size: 0.28rem;
      padding: 0.2rem 0;
      .left {
        width: 30%;
        text-align: right;
      }
      .right {
        width: 70%;

        padding-left: 0.1rem;
      }
    }
    .item:last-child {
      border-bottom: 1px solid #ddd;
    }
  }
  .more {
    padding: 0.4rem 0;
    display: flex;
    justify-content: center;
    .btn {
      font-size: 0.28rem;
      display: inline-block;
      vertical-align: top;
      border: 1px solid;
      border-radius: 1rem;
      padding: 0.1rem 0.3rem;
    }
  }
}
.windowInfoWrap {
  padding-bottom:30px;
  .tablebox {
    margin-top: 42px;
    /deep/.ant-table-thead > tr:first-child > th {
      background: #0078d4;
      font-size: 16px;
      height: 56px;
      text-align: center;
      color: #fff;
      font-weight: 100;
      border-left: 2px solid #fff;
    }
    /deep/.ant-table-tbody > tr > td {
      text-align: center;
      color: #474747;
      a {
        color: #474747;
      }
    }
  }
}

.m-screen-mobile {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  margin-bottom: 1rem;
}
</style>
